import { useRouter } from "next/router";

import { useGetDeviceType } from "_common/hooks/global";
import { useReels }         from "_common/hooks/useReels";
import { DefaultTags }      from "_common/seo";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import Icon                 from "_components/atoms/icon";
import Render               from "_components/atoms/render";
import ErrorPage            from "_components/features/creatorDashboard/atoms/dashboardErrorPage";
import ReelContainer        from "_components/pages/reels/components/reelContainer";

import useStyles from "./styles";

const ReelsPage = ( {
	userReels,
	fetchMoreReels,
	error,
	isLoading,
	isValidating
} ) => {

	const router      = useRouter ();
	const {
		currentIdx,
		scrollToComponent,
		componentRefs
	} = useReels ();
	const deviceType  = useGetDeviceType ();
	const { classes } = useStyles ( undefined, { name: "root" } );

	if ( error ) {
		return (
			<div className = { classes.errorPageWrapper }>
				<ErrorPage
					customMsg = "Something went wrong!!"
				/>
			</div>
		);
	}

	return (
		<BackgroundWrapper className = { `${ classes.reelsRoot } hideScrollbar` }
			type                        = "secondary"
		>
			<DefaultTags
				description = { "" }
				endpoint    = { router.asPath }
				title       = { userReels[currentIdx]?.title || "" }
			>

			</DefaultTags>

			<Render condition = { deviceType !== "mobile" }>
				<UpDownButtons
					currentIdx        = { currentIdx }
					scrollToComponent = { scrollToComponent }
				/>
			</Render>

			<div className = { classes.reelContainer }>
				{
					userReels?.map ( ( reel, index ) => {
						return (
							<ReelContainer
								key            = { index }
								ref            = { el => componentRefs.current[index] = el }
								fetchMoreReels = { fetchMoreReels }
								index          = { index }
								isLoading      = { isLoading }
								isValidating   = { isValidating }
								length         = { userReels.length }
								reel           = { reel }
							/>
						);
					} )
				}
			</div>
		</BackgroundWrapper>
	);

};

function UpDownButtons ( { currentIdx, scrollToComponent } ) {
	const showUpButton = currentIdx !== 0;
	const { classes }  = useStyles ( { showUpButton } );

	return (
		<div className    = { classes.buttonContainer }>
			<button className    = { classes.reelsScrollButton }
				data-showbtn        = { currentIdx !== 0 ? undefined : true }
				onClick             = { () => scrollToComponent ( currentIdx - 1 ) }
			>
				<Icon
					className = { classes.reelsIcon }
					name      = { "reelsUp" }
				/>
			</button>

			<button className = { classes.reelsScrollButton }
				onClick          = { () => {
					scrollToComponent ( currentIdx + 1 );
				} }
			>
				<Icon className = { classes.reelsIcon }
					name           = { "reelsDown" }
				/>
			</button>
		</div>
	);
}
export default ReelsPage;
